<template>
    <div class="block-editor holiday-plus-hotels">
        <div class="editor-row">
            <div class="editor-row-title">Hotel</div>
            <TiptapEditor
                placeholder="Adult Count"
                :show-attributes="true"
                :max-character-count="500"
                v-model="clone.hotelId"
            />
        </div>
        <div class="inputTitle mt-1 mb-2 font-weight-bold">{{ $t("chatbotv2.followingAttributesFilled") }}</div>
        <section class="next-step-filled-items-wrapper">
            <div class="logos middle-section" v-for="attr in nextStepFilledValue" :key="attr">
                <AttributeIconPreview :attribute="attr" />
                <span class="ml-2">
                    <AttributeLabel :attribute="attr" />
                </span>
            </div>
        </section>
    </div>
</template>

<script>
import log2 from "../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../common/TiptapEditor";
import AttributePicker from "../pickers/AttributePicker.vue";
import AttributeIconPreview from "../common/AttributeIconPreview.vue";
import AttributeLabel from "../common/tiptap-extensions/AttributeLabel.vue";

const log = log2("HolidayPlusRooms");
export default {
    name: "HolidayPlusRooms",
    components: { AttributeLabel, AttributeIconPreview, AttributePicker, TiptapEditor },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep(this.value),
            nextStepFilledValue: [
                "holiday_plus_room_id",
                "holiday_plus_room_roomtype_id",
                "holiday_plus_room_kontrat_id",
                "holiday_plus_room_konsept_id",
                "holiday_plus_room_konsept_adi_tr",
                "holiday_plus_room_description",
                "holiday_plus_room_min_nights",
                "holiday_plus_room_single_bay",
                "holiday_plus_room_currency_id",
                "holiday_plus_room_kura",
                "holiday_plus_room_kurs",
                "holiday_plus_room_currency_simge",
                "holiday_plus_room_metrekare",
                "holiday_plus_room_aciklama",
                "holiday_plus_room_aciklama_ozel",
                "holiday_plus_room_total",
                "holiday_plus_room_total_satis_final",
                "holiday_plus_room_iptal_guvence",
                "holiday_plus_room_is_stop",
                "holiday_plus_room_is_deadline",
            ],
        };
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss">
.block-editor.holiday-plus-hotels {
    padding: 20px;
    display: flex;
    gap: 20px;
    flex-direction: column;

    .editor-row {
        width: 100%;

        .editor-row-title {
            font-weight: bold;
            font-size: 16px;
            display: flex;
            align-items: center;
            gap: 5px;
        }
    }

    .next-step-filled-items-wrapper {
        background: #fff;
        border-radius: 6px;
        font-size: 14px;
        line-height: 18px;
        margin-bottom: 20px;
        padding: 20px;
        width: 100%;

        .middle-section {
            background: #ffdc66;
            cursor: pointer;
            transition: all 0.3s;
            border-radius: 10px;
            box-decoration-break: clone;
            display: flex;
            justify-content: center;
            padding: 5px;
            width: fit-content;
            margin: 5px;
            align-items: center;
            font-weight: 800;
        }
    }
}
</style>
